import axios from "axios";
import React, { useEffect, useState, useRef, useCallback } from "react";
import { useDispatch, useSelector } from "react-redux";
import { setActiveFilter, setContentBySlug } from "../../../redux/actions";
import { VIDEOS } from "../../../redux/constants";
import { fetchAllContent } from "../../../redux/dataFetchers/contentApi";
import PostCard from "../Post/PostCard";
import { fetchPostsById } from "../../../redux/dataFetchers/postApis";
import { useHistory } from "react-router-dom";
import LoadingAnimation from "../LoadingAnimation/LoadingAnimation";
import usePaginatedVideos from "./usePaginatedVideos";

function Videos() {
  const history = useHistory();
  const dispatch = useDispatch();
  const reduxState = useSelector((state) => state);
  const [pageNumber, setPageNumber] = useState(1);
  const observer = useRef();

  //use custom hook to paginate feed content
  const { loading, error, paginatedVideos, hasMore } = usePaginatedVideos(
    pageNumber
  );

  //as last content element is visible, load the next page content
  const lastVideoElementRef = useCallback(
    (node) => {
      if (loading) return;
      if (observer.current) observer.current.disconnect();

      observer.current = new IntersectionObserver((entries) => {
        if (entries[0].isIntersecting && hasMore) {
          setPageNumber((prevPageNumber) => prevPageNumber + 1);
        }
      });
      if (node) observer.current.observe(node);
    },
    [loading, hasMore]
  );

  useEffect(() => {
    setPageNumber(1);
  }, [reduxState.allContent.filteredVideos]);

  useEffect(() => {
    let pathname = history.location.pathname.split("/");
    const content = pathname[1],
      contentId = pathname[2];

    if (content === "videos" && contentId) {
      dispatch(fetchPostsById("video", contentId));
      dispatch(setContentBySlug(true));
    } else {
      dispatch(fetchAllContent());
      dispatch(setContentBySlug(false));
    }

    dispatch(setActiveFilter(VIDEOS));
  }, []);

  return (
    <div className="md:glass flex flex-col items-center mx-2">
      <div className="md:mx-48">
        {paginatedVideos?.length ? paginatedVideos?.map((content,index) => {
          return paginatedVideos.length == index + 1 ? (
            <PostCard ref={lastVideoElementRef} data={content} key={index} />
          ) : (
            <PostCard key={index} data={content} />
          );
        }) : !reduxState.loaders.feedLoader?
        <div style={{height:'80vh',display:'flex',justifyContent:'center',alignItems:'center',fontWeight:'bold',fontSize:'1.3rem',color:'gray'}}>No Videos Found</div>
          : null
          }
        {reduxState.loaders.feedLoader && <LoadingAnimation />}
        {reduxState.loaders.feedLoader && <LoadingAnimation />}
        {reduxState.loaders.feedLoader && <LoadingAnimation />}
        {reduxState.loaders.feedLoader && <LoadingAnimation />}
        {reduxState.loaders.feedLoader && <LoadingAnimation />}
      </div>
    </div>
  );
}

export default Videos;
